import { __extends, __assign } from './../../_node_modules/tslib/tslib.es6.js';
import { Http } from "./transports/http.js";
import { Config } from "../../../analytics-core/lib/esm/config.js";
var NodeConfig = (
  /** @class */
  function(_super) {
    __extends(NodeConfig2, _super);
    function NodeConfig2(apiKey, options) {
      return _super.call(this, __assign(__assign({ transportProvider: new Http() }, options), { apiKey })) || this;
    }
    return NodeConfig2;
  }(Config)
);
var useNodeConfig = function(apiKey, overrides) {
  return new NodeConfig(apiKey, overrides);
};
export {
  NodeConfig,
  useNodeConfig
};
//# sourceMappingURL=config.js.map
